import api from '@/lib/axios';
import type { PaginatedResult } from '@/components/data-table';

function unwrap<T>(r: { data: { data?: T } | T }): T {
  const body = r.data as { data?: T };
  return body && typeof body === 'object' && 'data' in body ? (body.data as T) : (r.data as T);
}

export interface OrgAcademicYearRow {
  name: string;
  startDate: string;
  endDate: string;
  schoolCount: number;
  totalSchools: number;
  currentInCount: number;
}

export interface CreateOrgAcademicYearData {
  name: string;
  startDate: string;
  endDate: string;
}

export interface UpdateOrgAcademicYearData {
  oldName: string;
  name?: string;
  startDate?: string;
  endDate?: string;
}

export type OrgAcademicYearActionStatus =
  | 'created'
  | 'updated'
  | 'deleted'
  | 'set_current'
  | 'skipped'
  | 'blocked'
  | 'not_found'
  | 'failed';

export interface OrgAcademicYearActionResult {
  schoolId: string;
  schoolName: string;
  status: OrgAcademicYearActionStatus;
  error?: string;
}

export const OrgAcademicYearsApi = {
  list: async (params?: { page?: number; limit?: number }): Promise<PaginatedResult<OrgAcademicYearRow> & { truncated: boolean }> =>
    unwrap(await api.get('/org/reports/academic-years', { params })),

  create: async (data: CreateOrgAcademicYearData): Promise<OrgAcademicYearActionResult[]> =>
    unwrap(await api.post('/org/reports/academic-years', data)),

  update: async (data: UpdateOrgAcademicYearData): Promise<OrgAcademicYearActionResult[]> =>
    unwrap(await api.patch('/org/reports/academic-years', data)),

  remove: async (name: string): Promise<OrgAcademicYearActionResult[]> =>
    unwrap(await api.delete('/org/reports/academic-years', { data: { name } })),

  setCurrent: async (name: string): Promise<OrgAcademicYearActionResult[]> =>
    unwrap(await api.post('/org/reports/academic-years/set-current', { name })),
};
